import {Component} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {MieterDaten} from '../../../models/mieter-daten.model';
import {HEIZUNG_CONFIG, TypeConfig} from '../../../models/overviewTypeConfig.model';
import {PageComponent} from '../../../page.component';

@Component({
  selector: 'mp-heizung',
  templateUrl: './heizung.component.html',
  styleUrls: ['./heizung.component.css']
})
export class HeizungComponent extends PageComponent{

  public mieterDaten: MieterDaten;
  typeConfig: TypeConfig = HEIZUNG_CONFIG;

  constructor(private apiService: ApiService) {
    super();
    this.mieterDaten = this.apiService.currentMieterDatenValue;
  }

  canGoBack(): boolean {
    return true;
  }
}
